const list = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15 1v14H1V1zm-1.5 9.5h-11v3h11zm0-4h-11V9h11zm0-4h-11V5h11z"/></svg>',
};

export { list as default };
